module.exports = __webpack_public_path__ + "static/media/flowers_8.c4bfa509.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_8.csv
// module id = 765
// module chunks = 0